<script setup>
import { useRouter } from 'vue-router'
import { navigationRecovery } from '@/composables/useNavigationRecovery.js'
const router = useRouter()
const retry = async () => {
    const target = navigationRecovery.target
    navigationRecovery.open = false
    await router.push(target).catch(() => {})
}
</script>

<template>
    <div v-if="navigationRecovery.open" class="navigation-recovery" role="alert">
        <span>This page could not be loaded. Save or cancel any unsaved changes, then try again.</span>
        <button type="button" @click="retry">Try again</button>
        <button type="button" aria-label="Dismiss" @click="navigationRecovery.open = false">×</button>
    </div>
</template>

<style scoped>
.navigation-recovery { position: fixed; z-index: 3000; top: 16px; left: 50%; transform: translateX(-50%); width: min(90vw, 720px); display: flex; align-items: center; gap: 12px; padding: 14px; border: 1px solid var(--surface-border); border-radius: 12px; background: var(--surface-card); color: var(--text-color); box-shadow: 0 8px 24px rgb(0 0 0 / 20%); }
.navigation-recovery span { flex: 1; }
.navigation-recovery button { flex: none; }
</style>
